export const trackAdWordsConversion = (conversionId, conversionLabel) => {
  if (typeof trackConversion === 'function') {
    // function 'trackConversion' is attached to window by ruby script
    trackConversion(conversionId, conversionLabel);
  }
};



// WEBPACK FOOTER //
// ./app/javascript/services/adWords.js